import { render, staticRenderFns } from "./NanHaiShiDianGongZuoTongZhi.vue?vue&type=template&id=1c267004&"
import script from "./NanHaiShiDianGongZuoTongZhi.vue?vue&type=script&lang=js&"
export * from "./NanHaiShiDianGongZuoTongZhi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports